"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.constructTxDataAny = exports.EvmModule = void 0;
const codec_1 = require("../codec");
const tx_1 = require("../codec/ethermint/evm/v1/tx");
const util_1 = require("../util");
const utils_1 = require("ethers/lib/utils");
const base_1 = __importDefault(require("./base"));
class EvmModule extends base_1.default {
    sendEvmTx(req, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = tx_1.MsgEthereumTx.fromPartial({
                data: constructTxDataAny(req),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgEthereumTx,
                value,
            }, opts);
        });
    }
}
exports.EvmModule = EvmModule;
// Referenced from ethermint v0.21.0 Switcheo/ethermint/x/evm/types/msg.go 
function constructTxDataAny(req) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
    const accessList = (req === null || req === void 0 ? void 0 : req.accessList) ? (0, utils_1.accessListify)(req.accessList).length > 0 : false;
    let txData = tx_1.LegacyTx.fromPartial({});
    let txType = "";
    if (!accessList) {
        txData = tx_1.LegacyTx.fromPartial({
            nonce: (_b = (_a = req.nonce) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "0",
            to: req.to,
            value: (_d = (_c = req.value) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : "0",
            gas: (_f = (_e = req.gasLimit) === null || _e === void 0 ? void 0 : _e.toString()) !== null && _f !== void 0 ? _f : "0",
            gasPrice: (_h = (_g = req.gasPrice) === null || _g === void 0 ? void 0 : _g.toString()) !== null && _h !== void 0 ? _h : "0",
            data: req.data ? (0, utils_1.arrayify)(req.data) : undefined,
        });
        txType = 'LegacyTx';
    }
    if (accessList && (req === null || req === void 0 ? void 0 : req.maxPriorityFeePerGas) && (req === null || req === void 0 ? void 0 : req.maxFeePerGas)) {
        txData = tx_1.DynamicFeeTx.fromPartial({
            chainId: (_k = (_j = req.chainId) === null || _j === void 0 ? void 0 : _j.toString()) !== null && _k !== void 0 ? _k : "0",
            nonce: (_m = (_l = req.nonce) === null || _l === void 0 ? void 0 : _l.toString()) !== null && _m !== void 0 ? _m : "0",
            to: req.to,
            value: (_p = (_o = req.value) === null || _o === void 0 ? void 0 : _o.toString()) !== null && _p !== void 0 ? _p : "0",
            gas: (_r = (_q = req.gasLimit) === null || _q === void 0 ? void 0 : _q.toString()) !== null && _r !== void 0 ? _r : "0",
            gasTipCap: (_t = (_s = req.maxPriorityFeePerGas) === null || _s === void 0 ? void 0 : _s.toString()) !== null && _t !== void 0 ? _t : "0",
            gasFeeCap: (_v = (_u = req.maxFeePerGas) === null || _u === void 0 ? void 0 : _u.toString()) !== null && _v !== void 0 ? _v : "0",
            data: req.data ? (0, utils_1.arrayify)(req.data) : undefined,
            accesses: req.accessList ? (0, utils_1.accessListify)(req.accessList) : undefined,
        });
        txType = 'DynamicFeeTx';
    }
    if (accessList) {
        txData = tx_1.AccessListTx.fromPartial({
            chainId: (_x = (_w = req.chainId) === null || _w === void 0 ? void 0 : _w.toString()) !== null && _x !== void 0 ? _x : "0",
            nonce: (_z = (_y = req.nonce) === null || _y === void 0 ? void 0 : _y.toString()) !== null && _z !== void 0 ? _z : "0",
            to: req.to,
            value: (_1 = (_0 = req.value) === null || _0 === void 0 ? void 0 : _0.toString()) !== null && _1 !== void 0 ? _1 : "0",
            gas: parseInt((_3 = (_2 = req.gasLimit) === null || _2 === void 0 ? void 0 : _2.toString()) !== null && _3 !== void 0 ? _3 : "0", 10),
            gasPrice: (_5 = (_4 = req.gasPrice) === null || _4 === void 0 ? void 0 : _4.toString()) !== null && _5 !== void 0 ? _5 : "0",
            data: req.data ? (0, utils_1.arrayify)(req.data) : undefined,
            accesses: req.accessList ? (0, utils_1.accessListify)(req.accessList) : undefined,
        });
        txType = 'AccessListTx';
    }
    return codec_1.registry.encodeAsAny({
        typeUrl: `/${tx_1.protobufPackage}.${txType}`,
        value: txData,
    });
}
exports.constructTxDataAny = constructTxDataAny;
